module.exports = __webpack_public_path__ + "img/personel-detail-1.png";